// app/javascript/controllers/modal_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["modal", "background", "content", "closeButton"]
  static values = {
    open: { type: Boolean, default: false },
    id: String
  }

  connect() {
    // 初期化時にモーダルを非表示にする
    this.closeModal()
    
    // ページロード時にハッシュを確認
    this.checkHashOnLoad()
    
    // ハッシュ変更時のイベントリスナーを追加
    window.addEventListener('hashchange', this.handleHashChange.bind(this))
  }

  disconnect() {
    // イベントリスナーをクリーンアップ
    window.removeEventListener('hashchange', this.handleHashChange.bind(this))
  }

  checkHashOnLoad() {
    const hash = window.location.hash
    if (hash.startsWith('#interview-')) {
      const voiceId = hash.replace('#interview-', '')
      this.openModalById(voiceId)
    }
  }

  handleHashChange() {
    const hash = window.location.hash
    if (hash.startsWith('#interview-')) {
      const voiceId = hash.replace('#interview-', '')
      this.openModalById(voiceId)
    } else {
      this.closeModal()
    }
  }

  openModal(event) {
    if (event) {
      event.preventDefault()
    }

    // カードから voice ID を取得
    const voiceId = event.currentTarget.dataset.voiceId
    this.openModalById(voiceId)
    
    // URLハッシュを更新（ブラウザの履歴に追加）
    const newHash = `#interview-${voiceId}`
    if (window.location.hash !== newHash) {
      window.history.pushState(null, '', newHash)
    }
  }

  openModalById(voiceId) {
    this.idValue = voiceId

    // 対応するモーダルを ID で検索
    const modalToShow = document.getElementById(`voice-modal-${voiceId}`)
    if (modalToShow) {
      // 既に開いているモーダルがあれば閉じる
      this.closeModal()

      // モーダルを表示
      modalToShow.classList.remove("hidden")

      // このモーダル内の背景とコンテンツ要素を取得
      const background = modalToShow.querySelector('[data-modal-target="background"]')
      const content = modalToShow.querySelector('[data-modal-target="content"]')

      // アニメーション適用
      setTimeout(() => {
        background.classList.remove("opacity-0")
        background.classList.add("opacity-100")
        content.classList.remove("opacity-0", "translate-y-8", "scale-95")
        content.classList.add("opacity-100", "translate-y-0", "scale-100")
      }, 10)

      // モーダルが開いている状態に更新
      this.openValue = true

      // 背景スクロールを防止
      document.body.classList.add("overflow-hidden")
    }
  }

  closeModal(event) {
    if (event) {
      event.preventDefault()
    }

    const openModal = document.querySelector('.voice-modal:not(.hidden)')

    if (openModal) {
      const background = openModal.querySelector('[data-modal-target="background"]')
      const content = openModal.querySelector('[data-modal-target="content"]')

      // アニメーション
      background.classList.remove("opacity-100")
      background.classList.add("opacity-0")
      content.classList.remove("opacity-100", "translate-y-0", "scale-100")
      content.classList.add("opacity-0", "translate-y-8", "scale-95")

      // モーダルを非表示
      setTimeout(() => {
        openModal.classList.add("hidden")
        this.openValue = false
        document.body.classList.remove("overflow-hidden")
      }, 300)
      
      // URLハッシュをクリア（ブラウザの履歴に追加）
      if (window.location.hash && window.location.hash.startsWith('#interview-')) {
        window.history.pushState(null, '', window.location.pathname)
      }
    }
  }

  // 背景クリックでモーダルを閉じる
  backgroundClick(event) {
    if (event.target.hasAttribute('data-modal-target') &&
        event.target.getAttribute('data-modal-target') === 'background') {
      this.closeModal()
    }
  }

  // ESCキーでモーダルを閉じる
  keydown(event) {
    if (this.openValue && event.key === "Escape") {
      this.closeModal()
    }
  }
}